import { matchRoutes, RouteMatch, useLocation } from 'react-router-dom';
import { untilLoad } from "@consumidor-positivo/ts-utils";

type UserDatadogProps = {
  pagePaths: Record<string, string>[] | [];
  privatePagePaths: string[];
  publicPagePaths: string[];
};

export default function useDatadog({ pagePaths, privatePagePaths, publicPagePaths }: UserDatadogProps) {
  const location = useLocation();

  async function runDatadogSetUser() {
    const getUser = localStorage.getItem('ac/AUTH_USER_DATA');
    const user = getUser ? JSON.parse(getUser || '') : {};
    const isPrivatePages = privatePagePaths.includes(location.pathname);
    const isPublicPages = publicPagePaths.includes(location.pathname);

    await untilLoad(() => window?.cpRedline?.ready, 7000);

    if (isPrivatePages) {
      window?.DD_RUM?.setUser({
        id: window?.cpRedline?.sessionID,
        sessionID: window?.cpRedline?.sessionID,
        appVersion: window?.cpRedline?.opts?.appVersion,
        customerIdHash: user?.customerIdHash,
        document: user?.documento,
        email: user?.email,
      });
    }

    if (isPublicPages) {
      window?.DD_RUM?.setUser({
        id: window?.cpRedline?.sessionID,
        sessionID: window?.cpRedline?.sessionID,
        appVersion: window?.cpRedline?.opts?.appVersion,
      });
    }
  }

  function runDatadogStartView() {
    const routeMatches = matchRoutes(pagePaths, location.pathname);
    const viewName = routeMatches && computeViewName(routeMatches);
    if (viewName) {
      window?.DD_RUM?.onReady(function () {
        window?.DD_RUM?.startView({ name: viewName });
        runDatadogSetUser();
      });
    }
  }

  return {
    runDatadogStartView,
  };
}

function computeViewName(routeMatches: RouteMatch[] | undefined) {
  let viewName = '';
  if (routeMatches) {
    for (let index = 0; index < routeMatches.length; index++) {
      const routeMatch = routeMatches[index];
      const path = routeMatch.route.path;
      if (!path) {
        continue;
      }

      if (path.startsWith('/')) {
        viewName = path;
      } else {
        viewName += viewName.endsWith('/') ? path : `/${path}`;
      }
    }
  }

  return viewName || '/';
}
